import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import Spinner from 'components/spinner/Spinner';

import { FILTER_OPTIONS } from 'utils/messenger';
import { __t, applyTranslations } from 'utils/language';

import './messenger-filter-by-state.scss';

applyTranslations(require('./messenger-filter-by-state.i18n.json'));

import type {
  Data,
  MixedSelectDropdownItem
} from 'types';

type CreatorsCount = {
  accepted: number,
  pending: number,
  revoked: number
};

type Props = {
  filterByState: string,
  creatorsCountByState: CreatorsCount,
  onClick: (a: string) => void,
  isConversationCountLoading: boolean
};

const MSG_KEY = 'messenger_filter_by_state';

function getCreatorsCountByState(creatorsCountByState: CreatorsCount | undefined | null, state: string) {
  if (!creatorsCountByState) {
    return 0;
  }

  if (state === 'all') {
    return creatorsCountByState.pending + creatorsCountByState.accepted + creatorsCountByState.revoked;
  }

  return creatorsCountByState[state];
}

class MessengerFilterByState extends React.PureComponent<Props> {
  getDropdownItems = (): Array<MixedSelectDropdownItem> => {
    const { filterByState, creatorsCountByState } = this.props;

    return FILTER_OPTIONS.map(value => ({
      identifier: value,
      isDisabled: false,
      isSelected: filterByState === value,
      label: __t(`${MSG_KEY}.options.${value}`, {
        creators: getCreatorsCountByState(creatorsCountByState, value)
      }),
      value
    }));
  };

  handleSelection = (
    updatedItems: Array<MixedSelectDropdownItem>,
    data?: Data | null,
    selectedItem?: Partial<MixedSelectDropdownItem> | null
  ): void => {
    const { onClick } = this.props;

    if (onClick) {
      onClick(selectedItem?.identifier || updatedItems[0].identifier);
    }
  };

  renderSelection(): React.ReactNode {
    const { filterByState, isConversationCountLoading } = this.props;
    const dropdownItems = this.getDropdownItems();

    return (
      <div className="messenger-filter-by-state__select">
        <div className="messenger-filter-by-state__label">
          {__t(`${MSG_KEY}.labels.filter_by`)}
        </div>
        {
          isConversationCountLoading ? (
            <div className="messenger-filter-by-state__spinner-container">
              <Spinner
                size="tiny"
                position="inline"
                color="light"
              />
            </div>
          ) : (
            <MixedSelectDropdown
              key={`messenger-filter-by-state__dropdown--${filterByState}`}
              name="messenger-filter-by-state__dropdown"
              items={dropdownItems}
              withSelectedInList
              className="messenger-filter-by-state__dropdown"
              onItemsToggle={this.handleSelection}
            />
          )
        }
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div
        className="messenger-filter-by-state"
        data-qa="messenger-filter-by-state"
      >
        {this.renderSelection()}
      </div>
    );
  }
}

export default MessengerFilterByState;
